import { render, staticRenderFns } from "./AlertBoxForm.vue?vue&type=template&id=15885271&"
import script from "./AlertBoxForm.vue?vue&type=script&lang=js&"
export * from "./AlertBoxForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports